import React from "react";
import { Modal } from "reactstrap";
import Edit from "../../views/ETIM/Edit";
import { FormattedMessage } from "react-intl";

export default function ETIMModal(props) {
  const { isOpen, toggle, id, etimClass } = props;
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="xl" fullscreen className="etim-modal">
      <div className="modal-header">
        <h5 className="modal-title">
          <i className="fa fa-cog mr-2"></i> <FormattedMessage id="etim.modal.title" defaultMessage="ETIM Modal" />
        </h5>
        <button type="button" className="close" onClick={toggle}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div className="modal-body">
        <Edit isModal={true} id={id} classEtim={etimClass} />
      </div>
    </Modal>
  );
}
